if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      const quickAddModal = document.querySelector('quick-add-modal');
      const isInQuickAddModal = quickAddModal ? true : false;

      if (window.enableSmartCart && this.submitButton && !isInQuickAddModal) {
        this.rebuyReady = false;
        this.rebuyTimeoutId = null;
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const loadingSpinner = this.querySelector('.loading-overlay__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }

        if (this.isRebuyReady()) {
          this.enableRebuyButton();
        } else {
          this.rebuyReadyHandler = this.onRebuyReady.bind(this);
          document.addEventListener('rebuy:smartcart.ready', this.rebuyReadyHandler, { once: true });

          this.rebuyTimeoutId = setTimeout(() => {
            if (!this.rebuyReady) {
              this.enableRebuyButton();
            }
          }, 2000);
        }
      } else {
        // If in quick-add-modal or Smart Cart disabled, mark as ready immediately
        this.rebuyReady = true;
      }
    }

    isRebuyReady() {
      return window.rebuy && typeof window.rebuy === 'object';
    }

    onRebuyReady() {
      if (this.rebuyReady) return;
      this.enableRebuyButton();
    }

    enableRebuyButton() {
      if (this.rebuyReady) return;

      if (this.rebuyTimeoutId) {
        clearTimeout(this.rebuyTimeoutId);
        this.rebuyTimeoutId = null;
      }

      if (this.rebuyReadyHandler) {
        document.removeEventListener('rebuy:smartcart.ready', this.rebuyReadyHandler);
        this.rebuyReadyHandler = null;
      }

      this.rebuyReady = true;

      let submitButton = this.submitButton;
      if (!submitButton || !submitButton.isConnected) {
        submitButton = this.querySelector('[type="submit"]');
      }

      if (submitButton) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
      }

      const loadingSpinner = this.querySelector('.loading-overlay__spinner');
      if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
      }
    }

    onSubmitHandler(evt) {
      const showAlert = false

      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      if (window.enableSmartCart && !this.rebuyReady) {
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // Ensure header bubble can update even without cart drawer
      const sectionsToRender = this.cart
        ? this.cart.getSectionsToRender().map((section) => section.id)
        : ['cart-icon-bubble'];
      formData.append('sections', sectionsToRender);
      formData.append('sections_url', window.location.pathname);
      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      let slsSellingPlanInput = this.form.querySelector('input[name="selling_plan"]');

      if (slsSellingPlanInput) {
        const frequencyDefault = this.dataset.frequencyDefault || 'monthly';
        const sellingPlanValue = slsSellingPlanInput.value;
        if (sellingPlanValue !== '') {
          // Helper to normalize frequency name to 'monthly' or 'biweekly'
          const normalizeFrequencyName = (name) => {
            if (!name) return null;
            if (/bi-?weekly/i.test(name)) return 'biweekly';
            if (/monthly/i.test(name)) return 'monthly';
            return null;
          };

          // Check if cart has quiz items - if so, match quiz frequency
          if (window.cartHasQuizItems && window.cartFrequencyId && window.cartFrequencyId !== '') {
            // Cart has quiz items - match their frequency (quiz is source of truth)
            const cartFrequencyType = normalizeFrequencyName(window.cartFrequencyName) || 'monthly';
            
            formData.set('selling_plan', window.cartFrequencyId);
            formData.set('properties[_selling_plan_id]', window.cartFrequencyId);
            formData.set('properties[_subscription_frequency]', cartFrequencyType);
          } else {
            // No quiz items - use form's default frequency in section settings
            formData.set('properties[_selling_plan_id]', sellingPlanValue);
            formData.set('properties[_subscription_frequency]', frequencyDefault);
          }
        }
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            // Update only the cart-count-bubble content inside header to preserve icon/text
            if (response && response.sections && response.sections['cart-icon-bubble']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');
              const newBubble = doc.querySelector('.cart-count-bubble');
              const bubbleWrapper = document.querySelector('#cart-icon-bubble .cart-count-bubble');
              if (newBubble && bubbleWrapper) bubbleWrapper.innerHTML = newBubble.innerHTML;
            }
            if (!window.enableSmartCart) {
              window.location = window.routes.cart_url;
            }
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          if (window.enableSmartCart) {
            // Update only the cart-count-bubble content inside header to preserve icon/text
            if (response && response.sections && response.sections['cart-icon-bubble']) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');
              const newBubble = doc.querySelector('.cart-count-bubble');
              const bubbleWrapper = document.querySelector('#cart-icon-bubble .cart-count-bubble');
              if (newBubble && bubbleWrapper) bubbleWrapper.innerHTML = newBubble.innerHTML;
            }
            return;
          }
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    disconnectedCallback() {
      // Cleanup: Remove event listeners and timeouts when component is removed from DOM
      if (!window.enableSmartCart) return;

      if (this.rebuyTimeoutId) {
        clearTimeout(this.rebuyTimeoutId);
        this.rebuyTimeoutId = null;
      }
      if (this.rebuyReadyHandler) {
        document.removeEventListener('rebuy:smartcart.ready', this.rebuyReadyHandler);
        this.rebuyReadyHandler = null;
      }
    }
  });
}
